"use strict";
exports.__esModule = true;
exports.STYLES = exports.BETWEEN = exports.GREATER = exports.LESS = exports.AT = void 0;
exports.AT = {
    'xs': 'at-xs:flex',
    'sm': 'at-sm:flex',
    'md': 'at-md:flex',
    'lg': 'at-lg:flex'
};
exports.LESS = {
    'md': 'lt-md:flex',
    'lg': 'lt-lg:flex'
};
exports.GREATER = {
    'xs': 'gt-xs:flex',
    'sm': 'gt-sm:flex'
};
exports.BETWEEN = {
    'xs-lg': 'bw-xs-lg:flex'
};
var STYLES = function (_a) {
    var at = _a.at, lessThan = _a.lessThan, greaterThan = _a.greaterThan, between = _a.between;
    var className = 'hidden';
    if (at) {
        className = "".concat(exports.AT[at], " ").concat(className);
    }
    else if (lessThan) {
        className = "".concat(exports.LESS[lessThan], " ").concat(className);
    }
    else if (greaterThan) {
        className = "".concat(exports.GREATER[greaterThan], " ").concat(className);
    }
    else if (between) {
        className = "".concat(exports.BETWEEN[between], " ").concat(className);
    }
    return className;
};
exports.STYLES = STYLES;
//# sourceMappingURL=media.style.js.map